import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'PaymentAccount',
    column_type: 'id',
  },
  created_at: {
    model_name: 'PaymentAccount',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'PaymentAccount',
    column_type: 'datetime',
  },
  name: {
    model_name: 'PaymentAccount',
    column_type: 'string',
  },
  code: {
    model_name: 'PaymentAccount',
    column_type: 'string',
  },
  position: {
    model_name: 'PaymentAccount',
    column_type: 'integer',
  },
  state: {
    model_name: 'PaymentAccount',
    column_type: 'enum',
  },
  remark: {
    model_name: 'PaymentAccount',
    column_type: 'string',
  },
  can_destroy: {
    model_name: 'PaymentAccount',
    column_type: 'string',
  },
  tax_rate: {
    model_name: 'PaymentAccount',
    column_type: 'decimal',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
